import { Box, Button, useToast, FormControl, FormLabel, Grid, Input, InputGroup, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Stack, Text, Spinner } from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { useForm, Controller } from "react-hook-form";
import { useLazyQuery } from '@apollo/client';
import { USER_LOGIN } from '../Graphql/Queries';
import { jwtDecode } from "jwt-decode";

export function LoginModal({ isOpen, onClose, onOpenSignupModal, onOpenForgotPasswordModal }) {
	const navigate = useNavigate();
	const [loginQuery, login] = useLazyQuery(USER_LOGIN);
	const toast = useToast();
	const { control, handleSubmit, formState: { errors }, trigger } = useForm();
	const lableStyle = {
		color: "#315B84",
		fontSize: "0.9rem",
		fontWeight: "500",
		lineHeight: "2",
	};
	const fieldStyle = {
		backgroundColor: "#f3f3f3",
		padding: "12px 15px"
	};
	const openForgotModal = () => {
		onClose()
		onOpenForgotPasswordModal()
	}
	const openSignUpModal = () => {
		onClose()
		onOpenSignupModal()
	}
	const onSubmit = (data) => {
		trigger().then(async (isValid) => {
			if (isValid) {
				try {
					console.log("Data in login modal is: ", data);
					const loginInput = {
						email: data.email,
						password: data.password
					};
					console.log(loginInput);
					await loginQuery({ variables: loginInput });
				}
				catch (error) {
					console.log("Error in login: ", error.response);
				}
			}
		});
	};
	useEffect(() => {

		console.log("error:", login.error)
		console.log("loading:", login.loading)
		console.log("data:", login.data)

		if (login.data != undefined) {
			if (login?.data?.login?.statusCode === 200) {
				sessionStorage.setItem("token", login.data?.login?.accessToken);
				let decodedJWT = login.data?.login?.accessToken && jwtDecode(login.data?.login?.accessToken);
				decodedJWT?.role === 'User' ? window.location.replace('/marketplace') : window.location.replace('/admin-dashboard');
				toast({
					title: 'Succeed',
					description: 'LogIn Successfully',
					status: 'success',
					duration: 4000,
					isClosable: true,
					position: "bottom-left"
				});
				// localStorage.setItem("userAddress", data.getAddress)
				// navigate('/dashboard');
			} else {
				toast({
					title: 'Error',
					description: login?.data?.login?.message,
					status: 'error',
					duration: 4000,
					isClosable: true,
					position: "bottom-left"
				});
			}
		}
		if (login.error != undefined) {
			toast({
				title: 'error',
				description: login.error.message,
				status: 'error',
				duration: 4000,
				isClosable: true,
				position: "bottom-left"
			});
		}
	}, [login.data, login.loading, login.error])
	return (
		<>
			<Modal
				isCentered
				isOpen={isOpen}
				onClose={onClose}
			>
				<ModalOverlay />
				<ModalContent backgroundColor={"#ececec"}>
					<ModalHeader mt={"25px"} fontSize={"32px"} fontWeight={"500"}>Login Account</ModalHeader>
					<ModalCloseButton mt={"35px"} size={"lg"} />
					<ModalBody pb={6}>
						<form onSubmit={handleSubmit(onSubmit)}>
							<FormControl id="email">
								<FormLabel {...lableStyle}>Email Address:</FormLabel>
								<Controller
									name="email"
									control={control}
									defaultValue=""
									rules={{ required: "Email is required" }}
									render={({ field }) => (
										<Input {...field} {...fieldStyle} type="email" placeholder="Enter your email address" />
									)}
								/>
								{errors.email && <Text color="red">{errors.email.message}</Text>}
							</FormControl>
							<FormControl id="password" mt={4}>
								<FormLabel {...lableStyle}>Password:</FormLabel>
								<Controller
									name="password"
									control={control}
									defaultValue=""
									rules={{
										required: "Enter your password", minLength: {
											value: 6,
											message: "Password must be at least 6 characters long",
										}
									}}
									render={({ field }) => (
										<InputGroup>
											<Input
												{...field}
												{...fieldStyle}
												type={"password"}
												placeholder="Enter your password"
											/>
										</InputGroup>
									)}
								/>
								{errors.password && (
									<Text color="red">{errors.password.message}</Text>
								)}
							</FormControl>
							<Button
								type="submit"
								// isLoading={login.loading}
								marginTop={"25px"}
								fontWeight={"500"}
								bg={"#002B5B"}
								color={"#fff"}
								_hover={{ bg: "#002B5B" }}
								w={"100%"}
								marginBottom={"10px"}
							>
								Login Now
							</Button>
						</form>
					</ModalBody>

					<ModalFooter marginBottom={"25px"}>
						<Grid templateColumns='repeat(1, 1fr)' gap={4} w={"100%"}>
							<Box fontSize={"14.4px"} fontWeight={"300"}><Text>NEW USER? <Text as="span" cursor="pointer" color="#315B84" onClick={openSignUpModal}>Sign up</Text></Text></Box>
							<Box fontSize={"14.4px"} fontWeight={"300"}><Text>FORGOT PASSWORD? <Text as="span" cursor="pointer" color="#315B84" onClick={openForgotModal}>Reset here</Text></Text></Box>
						</Grid>

					</ModalFooter>
				</ModalContent>
			</Modal>
			<Modal isOpen={login.loading} isCentered>
				<ModalOverlay />
				<ModalContent bg='transparent' display='flex' justifyContent='center' alignItems='center' boxShadow='none'>
					<Spinner color='blue.500' size='xl' emptyColor='gray.200' />
				</ModalContent>
			</Modal>
		</>
	)
}